export default __webpack_public_path__ + "static/media/grey-edit-circle-filled.9d11b838.svg";